import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type FormQuestion, isQuestionRequired } from '@pixacare/forms';
import { TuiHint, TuiIcon } from '@taiga-ui/core';
import { FormDisplayMode } from '../../form-grid/models/form-display-mode';

@Component({
  selector: 'pxc-form-question-label',
  templateUrl: './form-question-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiHint, TuiIcon],
})
export class FormQuestionLabelComponent {
  readonly question = input.required<FormQuestion>();
  readonly mode = input<FormDisplayMode>('form');

  readonly label = computed(() => this.question().title || this.question().label || '');
  readonly hint = computed(() => this.question().parameters?.hint);
  readonly isRequired = computed(() => isQuestionRequired(this.question()));
}
